import React from "react";
import { Layout, Row, Col } from "antd";
import qs from "query-string";

import unauthRoute from "../HOCs/UnauthRoute";
import {
  ForgotPasswordForm,
  ResetPasswordForm
} from "../Components/ForgotPassword";

import asXpertLogo from "../Assets/Images/ASxpert-logo.png";

const renderSteps = step => {
  if (step === "reset-password") {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center"
        }}
      >
        <img height={55} src={asXpertLogo} alt="AS Xpert Logo" />
        <h2>Nueva contraseña</h2>
        <ResetPasswordForm />
      </div>
    );
  }
  return null;
};

const ForgotPassword = ({ location }) => {
  const query = qs.parse(location.search);
  return (
    <Layout className="bg-img">
      <Row type="flex" justify="center" align="middle" style={{ flex: 1 }}>
        <Col
          className="signin-container"
          xs={{ span: 18 }}
          sm={{ span: 18 }}
          md={{ span: 12 }}
          lg={{ span: 8 }}
          xl={{ span: 4 }}
        >
          {query.step ? (
            renderSteps(query.step)
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center"
              }}
            >
              <img height={55} src={asXpertLogo} alt="AS Xpert Logo" />
              <h2>Recuperar contraseña</h2>
              <ForgotPasswordForm />
            </div>
          )}
        </Col>
      </Row>
    </Layout>
  );
};

export default unauthRoute(ForgotPassword);



// WEBPACK FOOTER //
// ./src/Pages/ForgotPassword.js